import { MatcherView, useMatcher } from "utils/MatcherProvider";
import { Breadcrumbs, Stack, styled, Typography } from "@mui/material";
import colors from "assets/theme-dark/base/colors";

export function Progress(): JSX.Element {
  const { activeMatcherView, changeView } = useMatcher();

  const breadcrumbs = [
    // <Option onClick={() => changeView(MatcherView.MAIN)} key={1} active={activeMatcherView === MatcherView.MAIN}>
    <Option onClick={() => {}} key={1} active={activeMatcherView === MatcherView.MAIN}>
      Setup
    </Option>,
    // <Option onClick={() => changeView(MatcherView.PREVIEW)} key={2} active={activeMatcherView === MatcherView.PREVIEW}>
    <Option onClick={() => {}} key={2} active={activeMatcherView === MatcherView.PREVIEW}>
      Preview
    </Option>,
    // <Option
    //   onClick={() => changeView(MatcherView.RESULTS)}
    //   active={activeMatcherView === MatcherView.RESULTS || activeMatcherView === MatcherView.DUPLICATES}
    //   key={3}
    // >
    <Option
      onClick={() => {}}
      active={activeMatcherView === MatcherView.RESULTS || activeMatcherView === MatcherView.DUPLICATES}
      key={3}
    >
      Match Result
    </Option>,
    // <Option onClick={() => changeView(MatcherView.SUMMARY)} active={activeMatcherView === MatcherView.SUMMARY} key={4}>
    <Option onClick={() => {}} active={activeMatcherView === MatcherView.SUMMARY} key={4}>
      Summary
    </Option>,
  ];

  return (
    <Breadcrumbs
      separator={
        <Stack sx={{ fontSize: "1rem" }} justifyContent="center" alignItems="center">
          {">"}
        </Stack>
      }
      aria-label="breadcrumb"
    >
      {breadcrumbs}
    </Breadcrumbs>
  );
}

const Option = styled("div")<{ active: boolean }>`
  color: ${({ theme, active }) => (active ? colors.text.main : theme.palette.grey[500])};
  font-size: 1rem;
  font-weight: ${({ active }) => (active ? 600 : 300)};
  // &:hover {
  // cursor: pointer;
  //   color: ${({ theme }) => colors.text.main};
  // }
`;
